<template>
  <div id="app">
    <div v-for="(data, index) in linkCardData" :key="index">
      <linkCardContainer
        :linkCardData="data.links"
        :title="data.category"
        :color="data.color"
      />
    </div>
  </div>
</template>

<script>
import linkCardContainer from "./components/linkCardContainer.vue";

export default {
  name: "App",
  components: {
    linkCardContainer,
  },
  computed: {
    linkCardData: {
      get() {
        return this.$store.state.linkCardData;
      },
    },
  },
  mounted: function() {
    let _this = this
    window.addEventListener("load", () => {
      _this.resize_iframe();
    });
  },
  updated: function() {
    this.resize_iframe();
  },
  methods: {
    resize_iframe: function() {
      // Find iframe in parent window.
      var iframes = window.top.document.getElementsByTagName("iframe");
      var iframe = null;
      for (var i = 0; i < iframes.length; i++) {
        var poss = iframes[i];
        var doc = poss.contentDocument || poss.contentWindow.document;
        if (doc == document) {
          iframe = poss;
          break;
        }
      }
      // If we can't find it, put a message in the console and abort.
      if (!iframe) {
        if (window.console) {
          console.log("VLE.resize_iframe: Unable to find parent iframe");
        }
        return;
      }
      // Calculate body height including margins.
      var html = document.getElementsByTagName("html")[0];
      var styles = getComputedStyle(html);
      var totalHeight =
        parseFloat(styles["marginTop"]) +
        parseFloat(styles["marginBottom"]) +
        html.offsetHeight;
      // Set the height.
      iframe.height = totalHeight;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
a:link {
  text-decoration: none !important;
  color: black;
}
a:visited {
  text-decoration: none !important;
  color: black;
}
.shrink:hover {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;

  -webkit-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);

  z-index: 1;
}
.shrink:focus {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;

  -webkit-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);

  z-index: 1;
}
/*






.cat-title {
  display: block;
}
*/
</style>

<!--
-->
